import { render, staticRenderFns } from "./authentications.vue?vue&type=template&id=602620d9&scoped=true"
import script from "./authentications.vue?vue&type=script&lang=ts"
export * from "./authentications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602620d9",
  null
  
)

export default component.exports